import { useEffect, useRef, useState } from "react";

type VersionPayload = {
  version: string;
  builtAt?: string;
};

export function useUiVersionWatcher(intervalMs = 60_000) {
  const currentVersionRef = useRef<string | null>(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const fetchVersion = async (): Promise<VersionPayload | null> => {
      try {
        console.log("Fetching UI version from /version.json");
        const res = await fetch("/version.json", { cache: "no-store" });
        if (!res.ok) return null;
        return await res.json();
      } catch {
        return null;
      }
    };

    const init = async () => {
      const v = await fetchVersion();
      if (!cancelled && v?.version) {
        currentVersionRef.current = v.version;
      }
    };

    const check = async () => {
      console.log("Checking for UI version update...");
      const v = await fetchVersion();
      console.log("Fetched UI version:", v);
      if (cancelled || !v?.version) return;

      console.log("Current UI version:", currentVersionRef.current);
      if (
        currentVersionRef.current &&
        v.version !== currentVersionRef.current
      ) {
        setUpdateAvailable(true);
      }
    };

    init();
    const id = setInterval(check, intervalMs);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [intervalMs]);

  const markReloaded = () => {
    // prevent repeated prompts after reload is accepted
    setUpdateAvailable(false);
  };

  return { updateAvailable, markReloaded };
}
